import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { SeoTags } from '../router';

const MetaTagSetter = ({ children }: { children: ReactNode }) => {
  const location = useLocation();

  return (
    <>
      {SeoTags(location.pathname)}
      {children}
    </>
  );
};

export default MetaTagSetter;
